export const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === "object" && value !== null;

export const hasStringProperty = (obj: Record<string, unknown>, key: string): boolean => {
    return key in obj && typeof obj[key] === "string";
};
